import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ChevronDownIcon from 'components/v2/icons/ChevronDownIcon';
import ChevronRightIcon from 'components/v2/icons/ChevronRightIcon';

export default class extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  handleToggleSection = () =>
    this.setState((prevState) => ({ open: !prevState.open }));

  render() {
    const { title, children } = this.props;

    const { open } = this.state;
    const toggleClassName = classnames({
      fa: true,
      'mr-0': true,
      'font-light': true,
    });

    const filtersClassName = classnames({
      'filters-list': true,
      'px-4': true,
      'pb-4': true,
      hide: !open,
      'border-b': true,
      'border-grey-light': true,
      'border-solid': true,
    });
    return (
      <div className="list-filter-group">
        <div className="heading flex justify-between pt-4 items-center">
          <h4 className="text-black text-sm m-0 pl-4">{title}</h4>
          <button className="button" onClick={this.handleToggleSection}>
            {open && <ChevronDownIcon />}
            {!open && <ChevronRightIcon />}

            <span className={toggleClassName} />
          </button>
        </div>
        <div className={filtersClassName}>{children}</div>
      </div>
    );
  }
}
